import React from 'react';

interface SelectedProductBannerProps {
  product: {
    id: number;
    name: string;
  };
  onRemove: () => void;
}

const SelectedProductBanner: React.FC<SelectedProductBannerProps> = ({ product, onRemove }) => {
  return (
    <div className="bg-green-50 border-t border-b border-green-200 px-4 py-3">
      <div className="max-w-4xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-2 text-green-700 text-sm">
          <span>📦</span>
          <span>選択中の商品/サービス：<strong>{product.name}</strong></span>
        </div>
        <button
          onClick={onRemove}
          className="text-green-600 hover:text-green-800 hover:bg-green-100 rounded-full p-1 transition-colors"
          aria-label="選択を解除"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default SelectedProductBanner;
